import { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useForm } from 'react-hook-form'
import { useNavigate } from 'react-router'
import confetti from 'canvas-confetti'
import { Container, Modal, Icon, TypoGraph } from 'components'
import styles from './successPage.module.scss'

interface IWidgetSuccessPageProps {
  isOneNetwork?: boolean
  messageTitle?: string
  messageText?: string
}

const WidgetSuccessPage: React.FC<IWidgetSuccessPageProps> = (props) => {
  const { messageTitle, messageText } = props

  const [mobileView, setMobileView] = useState(window.innerWidth < 1000)

  const navigate = useNavigate()

  const companyProfile = useSelector(
    (state: any) => state?.whiteLabel?.companyProfile
  )

  const methods = useForm<any>({
    reValidateMode: 'onChange',
  })
  useEffect(() => {
    confetti({
      particleCount: 150,
      spread: 110,
      origin: { y: 0.8 },
      zIndex: 100000,
    })
  }, [])

  const ModalContent = () => {
    return (
      <Container
        className={`${styles.modalContentContainer} ${
          mobileView && styles.mobileModalContent
        }`}
      >
        {companyProfile?.logo ? (
          <Icon
            type="images"
            url={companyProfile?.logo}
            boxClassName="fullLogo"
            width={300}
            height={100}
          />
        ) : (
          <Icon
            name={'icon_logoFullname' ?? 'icon_logo'}
            width={300}
            height={50}
          />
        )}
        <Container className={styles.titleContainer}>
          <TypoGraph
            variant="h1"
            content={messageTitle}
            sx={{ textAlign: 'center' }}
          />
          <TypoGraph
            variant="body2"
            content={messageText}
            sx={{ textAlign: 'center' }}
          />
          <Icon name="icon_dialog_success" size={mobileView ? 150 : 300} />
        </Container>
      </Container>
    )
  }

  return (
    <>
      <Modal
        open={true}
        dom={<ModalContent />}
        dismissOnClose={false}
        className={styles.showScrollbar}
        backdropFused={true}
      />
    </>
  )
}

export default WidgetSuccessPage
